import withStyles from '@mui/styles/withStyles';

function ValidationBadges(props) {
    const { classes, tabID } = props;
    return (
        <div className={classes.badgeContainer}>
            <div title={'Please fix required fields'} className={classes.badgeError} tab-error={tabID} />
            <div title={'Please check suggested fields'} className={classes.badgeSuggested} tab-suggested={tabID} />
            <div
                title={'Fields do not match data from Family'}
                className={classes.badgeOptional}
                tab-optional={tabID}
            />
        </div>
    );
}

const styles = ({ palette }) => ({
    badgeContainer: {
        display: 'flex',
        '& > *': {
            borderRadius: '50% 50%',
            alignContent: 'center',
            height: '20px',
            width: '20px',
            fontSize: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '3px',
            display: 'none' //flex
        }
    },
    badgeError: {
        color: '#FFFFFF',
        backgroundColor: palette.validation.error
    },
    badgeSuggested: {
        color: '#FFFFFF',
        backgroundColor: palette.validation.suggested
    },
    badgeOptional: {
        color: '#FFFFFF',
        backgroundColor: palette.validation.optional
    }
});

export default withStyles(styles)(ValidationBadges);
